import { render, staticRenderFns } from "./two-level.vue?vue&type=template&id=2e265b8e&scoped=true&"
import script from "./two-level.vue?vue&type=script&lang=js&"
export * from "./two-level.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e265b8e",
  null
  
)

export default component.exports